/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Who made a review decision: the review agent or an admin
 */
export enum HubDecider {
  agent = 'agent',
  admin = 'admin'
}
